import React, { createContext, useEffect, useState } from "react";
import { onAuthStateChanged} from "firebase/auth"
import {auth, db} from "../../firebase/config"
import { collection, getDocs, query, where } from "firebase/firestore";
export const Authcontext=createContext();
export const Authcontextprovider=(props)=>{
    const [currentuser,setCurrentuser]=useState({})
    const [usertype,setUsertype]=useState("")
    useEffect(()=>{
        onAuthStateChanged(auth,async (user)=>{
            if(currentuser){
                try{
                    const q = query(collection(db, "users"), where("uid", "==", user.uid));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((doc) => {
                        setUsertype(doc.data().rule)
                        setCurrentuser(doc.data())
                    });
                }catch(error){
                   
                }
            }
        })
    },[currentuser])
    return(
        <Authcontext.Provider value={{currentuser,usertype}} >
            {props.children}
        </Authcontext.Provider>
    )
}